export default "__VITE_ASSET__7781bb1e__"